import ArtworkRoutes from './routes'

const ArtworkBuilder = () => (
  <ArtworkRoutes />
)

export default ArtworkBuilder
